export enum TabsEnum {
    INCIDENTS = "INCIDENTS",
    QUEUE = "QUEUE",
    CLASSIFIERS = "CLASSIFIERS",
}
